module.exports = __webpack_public_path__ + "static/img/logo_imesp.ba81a7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/logo_imesp.png
// module id = WLoS
// module chunks = 232